import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PI } from '../constants-types/PI.model';
import { ConfigurationService } from '../system-configuration/Configuration.service';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { Logger } from '../system-services/Logger/Logger.service';
import { ExternalService } from './external-service.interface';

@Injectable({
    providedIn: 'root'
})
export class AdblockDetectorService {
    private loggingServiceEndpoint = 'api/LogRequest';

    private logTitle = 'Network call to Service blocked by Adblocker or Other';

    private services: ExternalService[] = [
        {
            name: 'Pendo',
            link: PI.appSettings.pendoApiKey ? `https://cdn.pendo.io/agent/static/${PI.appSettings.pendoApiKey}/pendo.js` : '',
            method: 'GET'
        },
        {
            name: 'GoogleTagManager',
            link: 'https://www.googletagmanager.com/gtag/js?id=AW-972820837',
            method: 'GET'
        }
    ];

    constructor(
        private initDataService: InitDataService,
        private http: HttpClient,
        private config: ConfigurationService,
        private logger: Logger
    ) {}

    /**
     * This method pings the external services we use
     * It errors out when an adblocker is active
     */
    checkAndLogIfServiceBlocked(): void {
        this.services.filter((service) => service.link).forEach((service) => {
            firstValueFrom(
                this.http.request(service.method, service.link)
            ).catch((error) => {
                if (error.status === 0)
                    this.logUserInformationUsingLoggingAPIService(service.name);
                this.logUserInformationUsingLogentrysAPI(service.name);
            });
        });
    }

    private logUserInformationUsingLoggingAPIService(
        blockedService: string
    ): void {
        const body = {
            userId: this.initDataService.user.userGuid,
            company: this.initDataService.user.company,
            blockedService: blockedService
        };

        fetch(this.buildLoggingUrl(), {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            },
            keepalive: true
        }).catch((error) => console.log(error));
    }

    private logUserInformationUsingLogentrysAPI(blockedService: string) {
        this.logger.logInfo(this.logTitle, {
            userId: this.initDataService.user.userGuid,
            company: this.initDataService.user.company,
            blockService: blockedService
        });
    }

    private buildLoggingUrl(): string {
        return `${this.config.getLoggingServiceAPIUrl()}${
            this.loggingServiceEndpoint
        }?${this.getEncodedQueryParams('message', this.logTitle)}`;
    }

    private getEncodedQueryParams(key: string, value: string): string {
        return encodeURI(`${key}=${value}`);
    }
}
